// extracted by mini-css-extract-plugin
module.exports = {"infoTitle":"Title_infoTitle__zElZS","titleIconWrap":"Title_titleIconWrap__1VbWi","page2Title":"Title_page2Title__2IKfa"};